<template>
  <div class="usr-info">
    <el-breadcrumb class="admin-path" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>用户中心</el-breadcrumb-item>
      <el-breadcrumb-item>用户个人信息维护</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="container" v-if="data">
      <el-form class ="search-form" :inline="true" :model="UsrInfoForm" label-position="right">
        <el-form-item  label="ID" >
          <el-input v-model="data.id" autocomplete="off" style="width:240px;" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="高能所用户ID">
          <el-input v-model="data.umtId" autocomplete="off" style="width:240px;" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="姓名">
          <el-input v-model="data.truename" autocomplete="off" style="width:240px;" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="cst网ID">
          <el-input v-model="data.cstnetId" autocomplete="off" style="width:240px;" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="类型">
          <el-input v-model="data.type" autocomplete="off" style="width:240px;" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="用户邮件地址">
          <el-input v-model="data.useremail" autocomplete="off" style="width:240px;" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="是否管理员">
          <el-input v-model="data.isadmin" autocomplete="off" style="width:240px;" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="用户电话">
          <el-input v-model="data.userphone" autocomplete="off" style="width:240px;" ></el-input>
        </el-form-item>
        <el-form-item label="用户单位">
          <el-input v-model="data.usercp" autocomplete="off" style="width:240px;" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="用户职位" v-if="false">
          <el-input v-model="data.userposition" autocomplete="off" style="width:240px;" :disabled="true"></el-input>
        </el-form-item>    
        <el-form-item label="备注">
          <el-input v-model="data.remarks" autocomplete="off" style="width:240px;" ></el-input>
        </el-form-item>          
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button @click="UserMgEdit">修改</el-button>
      </div>
    
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';
export default {
  name: 'usrceninfo',
  data() {
    return {
      UsrInfoForm: {

      },
      list: [],
      data:null,
    };
  },
  computed: {
    ...mapState([
      'userInfo',
      'language',
    ]),
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      const params = {
        email:this.userInfo.useremail,
      }
      axios.post('/iapi/getsingleData', params).then((res) => {
        if (res.data.errcode === 0) {
          this.data = res.data.data;
        } else {
          this.$message.error('数据不存在');
        }
      });
    },


    UserMgEdit(){
      // console.log('data',this.data);
      const params = {
        id : this.data.id,
        umtId : this.data.umtId,
        truename : this.data.truename,
        cstnetId : this.data.cstnetId,
        type : this.data.type,
        useremail : this.data.useremail,
        isadmin : this.data.isadmin,
        userphone : this.data.userphone,
        usercp : this.data.usercp,
        userposition : this.data.userposition,
        remarks : this.data.remarks,
      }
      axios.post('/iapi/usermgedit', params).then((res) => {
        if (res.data.errcode === 0) {
          this.$message('编辑用户信息成功！');
        }
      });
      this.getData();  
    },
  },
};
</script>

<style scoped>
.usr-info {
  padding: 24px 56px;
}
.container {
  background: #fff;
  border-radius: 2px;
}
.search-form {
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 8px;
  padding-bottom: 8px;
}
.el-form-item {
    color: blue;
    margin-top: 10px;
    margin-bottom: 10px;
}
.admin-path {
  margin-bottom: 16px;
}
</style>